/*
 * @Description: 语言切换
 * @Version: 0.0.1
 * @Author: yujiangping
 * @Date: 2025-06-10 11:40:28
 * @LastEditors: yujiangping
 * @LastEditTime: 2025-09-15 10:44:38
 */
// src/composables/useLocale.js
import { ref,watch } from 'vue';

const LOCALE_KEY = 'lang';
const SUPPORTED_LOCALES = {
  'zh-CN': () => import('../locales/zh-CN'),
  'en-US': () => import('../locales/en-US'),
};

function getBrowserLocale() {
    const saved = localStorage.getItem(LOCALE_KEY);
    if (saved && saved in SUPPORTED_LOCALES) return saved;

    const browserLang = navigator.language || navigator.languages[0];
    return browserLang.startsWith('zh') ? 'zh-CN' : 'en-US';
}

export function useLocale(i18n) {
  const locale = ref(getBrowserLocale());

  async function setLocale(newLocale) {
    if (!(newLocale in SUPPORTED_LOCALES)) return;
    // 添加 i18n 检查
    if (!i18n || !i18n.global) {
      console.warn('i18n instance not available');
      return;
    }
    if (i18n.global.availableLocales.indexOf(newLocale) < 0) {
      const messages = await SUPPORTED_LOCALES[newLocale]();
      i18n.global.setLocaleMessage(newLocale, messages.default);
    }

    i18n.global.locale.value = newLocale;
    locale.value = newLocale;
    localStorage.setItem(LOCALE_KEY, newLocale);
    window.location.reload();
  }

  //监听 i18n locale 变化同步到 ref
  if (i18n && i18n.global) {
    watch(() => i18n.global.locale.value, (val) => {
      locale.value = val;
    });
  }

  return {
    locale,
    setLocale,
    supportedLocales: Object.keys(SUPPORTED_LOCALES),
  };
}